import React from 'react';
import { Heading, Typography } from '@fiverr-private/typography';
import { Container, Stack } from '@fiverr-private/layout_components';
import { Tag } from '@fiverr-private/data_display';
import { RelatedLinksData } from '../../types';

export interface RelatedLinksProps {
  title: string;
  relatedLinks: RelatedLinksData;
  isVerticalPage?: boolean;
}

const CONFIG = {
  DEFAULT: {
    borderColor: 'grey_500',
    headingAs: 'h2',
    paddingBottom: '8',
    paddingX: '5',
    paddingTop: '12',
    headingSize: { default: 'h_sm', md: 'h_xl' },
    headingMarginBottom: { default: '6', sm: '8' },
  },
  VERTICAL: {
    borderColor: 'transparent',
    headingAs: 'h4',
    paddingBottom: { default: '12', sm: '16' },
    paddingX: { default: '6', sm: '8' },
    paddingTop: { default: '6', sm: '8' },
    headingSize: {},
    headingMarginBottom: { default: '8', sm: '12' },
  },
} as const;

export const RelatedLinks = ({ title, relatedLinks = { items: [] }, isVerticalPage }: RelatedLinksProps) => {
  const config = CONFIG[isVerticalPage ? 'VERTICAL' : 'DEFAULT'];

  return (
    <Container
      borderTopWidth="sm"
      borderColor={config.borderColor}
      borderStyle="solid"
      as="section"
      paddingBottom={config.paddingBottom}
      paddingX={config.paddingX}
      paddingTop={config.paddingTop}
      width="100%"
    >
      <Heading
        as={config.headingAs}
        size={config.headingSize}
        marginBottom={config.headingMarginBottom}
        textAlign="center"
      >
        {title}
      </Heading>
      <Stack gap="4" wrap="wrap" justifyContent="center">
        {!!relatedLinks.items?.length &&
          relatedLinks.items.map((link, index) => (
            <Tag href={link.url} target="" ariaLabel={link.text} key={index}>
              <Typography size="b_sm" color="grey_1000">
                {link.text}
              </Typography>
            </Tag>
          ))}
      </Stack>
    </Container>
  );
};
